import HandshakeIcon from '@mui/icons-material/Handshake';
import PlaceIcon from '@mui/icons-material/Place';
import RecommendIcon from '@mui/icons-material/Recommend';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { tr } from 'src/locales/tr';

export const CATEGORY_META = {
    trustedColleagues: {
        title: tr("Trusted Colleagues"),
        description: tr("Contractors you recommend to others"),
        color: 'success',
        icon: <RecommendIcon fontSize="small" />
    },
    localPros: {
        title: tr("Local Pros"),
        description: tr("Fellow builders and tradespeople nearby"),
        color: 'info',
        icon: <PlaceIcon fontSize="small" />
    },
    pastClients: {
        title: tr("Past Clients"),
        description: tr("Homeowners you've completed work for"),
        color: 'warning',
        icon: <HandshakeIcon fontSize="small" />
    },
    interestedHomeowners: {
        title: tr("Interested Homeowners"),
        description: tr("Potential clients checking your profile"),
        color: 'secondary',
        icon: <VisibilityIcon fontSize="small" />
    }
};
